import { render } from "./ContactLink.vue?vue&type=template&id=3a474db4&scoped=true"
import script from "./ContactLink.vue?vue&type=script&lang=js"
export * from "./ContactLink.vue?vue&type=script&lang=js"

import "./ContactLink.vue?vue&type=style&index=0&id=3a474db4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a474db4"]])

export default __exports__